import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userDetailsState } from 'states';
import { isBBEnvAvailable } from 'util/bloomberg';
import { getHasLoggedIn } from 'util/shared';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from './Link';
import { useClearLoginState } from 'hooks/useClearLoginState';

interface LogoutLinkProps {
  onClickCallback?: () => void;
}

const LogoutLink = ({ onClickCallback }: LogoutLinkProps) => {
  const navigate = useNavigate();
  const userDetails = useRecoilValue(userDetailsState);
  const { clearLoginState } = useClearLoginState();

  return !isBBEnvAvailable() ? (
    userDetails == null ? (
      <Link
        isLabelShown
        onClick={() => {
          onClickCallback?.();
          navigate('/login');
        }}
        to="/login"
        text="Login"
        icon={<LoginIcon width="24px" />}
      />
    ) : (
      <Link
        isLabelShown
        onClick={() => {
          clearLoginState();
          // If user has already logged in
          // logout will direct them back to login page
          onClickCallback?.();
          if (getHasLoggedIn()) {
            navigate('/login');
          }
        }}
        to="/home"
        text="Logout"
        disableActive={true}
        icon={<LogoutIcon width="24px" />}
      />
    )
  ) : null;
};

export default LogoutLink;
